import { render, staticRenderFns } from "./LinkColumn.vue?vue&type=template&id=1c0fc286&scoped=true&"
import script from "./LinkColumn.vue?vue&type=script&lang=js&"
export * from "./LinkColumn.vue?vue&type=script&lang=js&"
import style0 from "./LinkColumn.vue?vue&type=style&index=0&id=1c0fc286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0fc286",
  null
  
)

export default component.exports